import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Button from "primevue/button"
  import { computed } from "vue"
  import { FasesDaAtividade } from "@/repositorios/atividades/atividades.modelos"
  import { useI18n } from "vue-i18n"

  interface Props {
    estaCarregando: boolean
    faseDaAtividade: FasesDaAtividade
    desabilitar?: boolean
  }

  interface Emissoes {
    (event: "iniciarAtividade"): void
    (event: "finalizarAtividade"): void
    (event: "proximoPasso"): void
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ABotaoDeAcao',
  props: {
    estaCarregando: { type: Boolean },
    faseDaAtividade: null,
    desabilitar: { type: Boolean }
  },
  emits: ["iniciarAtividade", "finalizarAtividade", "proximoPasso"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "iniciarAtividade"): void
    (event: "finalizarAtividade"): void
    (event: "proximoPasso"): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    estaCarregando: boolean
    faseDaAtividade: FasesDaAtividade
    desabilitar?: boolean
  }

  const { t } = useI18n()

  
  

  const botaoAtividade = computed(() => {
    const estadosDoBotao = {
      podeSerIniciada: {
        classeComModificador: "ABotaoDeAcao__Botao--Inicializado",
        texto: t("iniciarAtividade"),
        acao: () => emitir("iniciarAtividade"),
      },
      emAndamento: {
        classeComModificador: "ABotaoDeAcao__Botao--Finalizado",
        texto: t("finalizarAtividade"),
        acao: () => emitir("finalizarAtividade"),
      },
      proximoPasso: {
        classeComModificador: "ABotaoDeAcao__Botao--Inicializado",
        texto: t("iniciarAtividade"),
        acao: () => emitir("proximoPasso"),
      }
    }

    const indiceDaPropriedade = props.faseDaAtividade

    return estadosDoBotao[indiceDaPropriedade]
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    onClick: _unref(botaoAtividade).acao,
    "aria-label": _unref(botaoAtividade).texto,
    class: _normalizeClass(["ABotaoDeAcao__Botao", _unref(botaoAtividade).classeComModificador]),
    "data-testid": "ABotaoDeAcao__Botao",
    label: _unref(botaoAtividade).texto,
    loading: __props.estaCarregando,
    disabled: __props.desabilitar
  }, null, 8, ["onClick", "aria-label", "class", "label", "loading", "disabled"]))
}
}

})